import $ from "jquery"
import "slick-carousel"

window.jQuery = $
window.$ = $

import Menu from "./menu"
import Venues from "./venues"
import "./customselect"

class App {
  constructor () {
    $(() => {
      console.log('APP.JS LOADED')

      this.venues = new Venues()

      this.venues.init();

      // Initialise menu
      this.menu = new Menu()
      //this.contactForm = new ContactForm()

      /* search form */
      $('.toggle-search').on('click', ({currentTarget}) => {
        const target = $(currentTarget).data('target')
        $(currentTarget).toggleClass('show')
        $(`#${target}`).toggleClass('show')
      })

      $('.search-close').on('click', ({currentTarget}) => {
        const target = $(currentTarget).data('target')
        $(currentTarget).toggleClass('show')
        $(`#${target}`).toggleClass('show')
      })

      $('.venue-video .play').on('click', ({currentTarget}) => {
        $(currentTarget).parent().find("iframe").show();
        $(currentTarget).parent().find("iframe")[0].src += "&autoplay=1"
      })

        $('.fv-toggle').on('click', ({currentTarget}) => {
           var rel = $(currentTarget).attr('rel');
           $(".venues-slider").removeClass('show');
           $("#"+rel).addClass("show");
           return false;
        });

      // Initialise slider
      $('.hero .slider').slick({
        arrows: true,
        infinite: true,
        speed: 600,
        dots: true,
        autoplay:true
      })

      // Initialise slider
      $('.testimonials-slider .slider').slick({
        arrows: true,
        infinite: true,
        speed: 600,
        dots: false,
        autoplay:false,
        slidesToShow: 3,
        responsive: [ {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
        },{
              breakpoint: 768,
              settings:{
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
          } ]
      })

      $('.testimonial-quotes.slider').slick({
        arrows: true,
        infinite: true,
        speed: 1200,
        dots: false,
        autoplay:true,
        autoplaySpeed: 8000,
        slidesToShow: 1
      })

      $('.latest-news .slider').slick({
        arrows: true,
        infinite: true,
        speed: 600,
        dots: false,
        autoplay:false,
        slidesToShow: 3,
        responsive: [ {
            breakpoint: 1087,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
        },{
              breakpoint: 768,
              settings:{
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
          } ]
      })

    })
  }
}

window.app = new App();
